import startCar from "@services/startCar";
import { alertPopup } from "@utils/popup";
import { Button, Icon, Input, Spin } from "antd";
import React from "react";

class AddStartAgentPopup extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            loading: false,
            inputs: {
                phone: '',
                name: '',
                email: ''
            },
            emailList: []
        }
    }

    componentDidMount() {
        window.addEventListener('click', this.closeOnOutClick)

        const { editAgent } = this.props
        if (editAgent) {
            const {
                name,
                phone,
                email
            } = editAgent

            this.setState({
                inputs: {
                    name,
                    phone: phone ? `0${phone}` : ''
                },
                emailList: JSON.parse(email || '[]')
            })
        }
    }

    componentWillUnmount() {
        window.removeEventListener('click', this.closeOnOutClick)
    }

    closeOnOutClick = (e) => {        
        if (e.target.id == 'start-add-agent-wrapper') {
            this.props.close()
        }
    }

    onInput = (e) => {
        let { id, value } = e.target
        const field = id.substring(0, id.lastIndexOf('_'))

        if (field == 'phone') {
            value = value.replace(/\D/g, '')
            if (value.length > 10) return
        }

        this.setState({ inputs: { ...this.state.inputs, [field]: value } })
    }

    handleEmail = () => {
        const { inputs: { email }, emailList } = this.state
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
        if (!emailPattern.test(email)) return
        let list = [...emailList]
        list.push(email)
        this.setState({ emailList: list, inputs: { ...this.state.inputs, email: '' } })
    }

    submit = () => {

        const { inputs, emailList } = this.state
        const { editAgent } = this.props

        let payload = {
            ...inputs,
            phone: inputs.phone.replace(/^0/, ''),
            email: editAgent ? JSON.stringify(emailList) : emailList,
            id: editAgent ? editAgent.id : ''
        }

        let service
        if (editAgent) {
            service = startCar.editStartAgent
            payload = { patchObject: payload }
        }
        else service = startCar.addStartAgent

        this.setState({ loading: true }, () => {
            service(payload)
            .then((res) => {
                // console.log('res add/edit start agent', res);
                // this.setState({ loading: false })
                this.props.getAgents()
                this.props.close()
            })
            .catch((error) => {
                console.log('error add/edit start agent', error.response);
                this.setState({ loading: false })

                let type = 'error', title = 'אירעה שגיאה', body = 'הפעולה נכשלה'

                if (error.response.status == 405) {
                    type = 'alert'
                    title = `לא ניתן ${editAgent ? 'לערוך את פרטי' : 'לרשום את'} הסוכן`
                    body = 'מספר הנייד קיים במערכת'
                }
                alertPopup({ type, title, body })
            })
        }) 
    }

    valid = () => {
        const { inputs, emailList } = this.state

        return (
            inputs.name &&
            inputs.phone &&
            inputs.phone.length == 10 &&
            emailList.length
        )
    }

    field = (fieldName) => {

        const fieldNames = {
            phone: 'נייד',
            name: 'שם מלא',
            email: 'אימייל'
        }

        const isEmail = fieldName == 'email'

        const inputStyle = {
            width: isEmail ? '380px' : '208px',
            borderRadius: isEmail ? '0 3px 3px 0' : ''
        }
        const buttonStyle = {
            background: 'white',
            borderRadius: '3px 0 0 3px',
            border: 'solid #d1d1d1 1px',
            width: '58px',
            height: '32px',
            cursor: 'pointer',
            textAlign: 'center',
            // fontHeight: '0px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
        }
        const emailItemStyle = {
            padding: '3px',
            border: 'solid #d1d1d1 1px',
            borderRadius: '0 3px 3px 0',
            width: '380px'
        }

        const removeEmailFromlist = (email) => {
            let emailList = [...this.state.emailList]
            let idx = emailList.indexOf(email)
            emailList.splice(idx, 1)
            this.setState({ emailList })
        }
        

        const { emailList } = this.state

        return (
            <div style={{ ...styles.column, alignItems: 'start', marginLeft: '20px' }}>
                <span>{`${fieldNames[fieldName]}:`}</span>
                <div style={{ display: 'flex' }}>
                    <Input style={inputStyle} id={`${fieldName}_input`} value={this.state.inputs[fieldName]} onChange={this.onInput} />
                    {isEmail ?
                    <div onClick={this.handleEmail} style={buttonStyle}>{"הוספה"}</div> : ''}
                </div>
                {isEmail ?
                <div style={{ ...styles.column, maxHeight: '68px', minHeight: '40px' overflowY: 'auto', width: '438px' }}>
                    {emailList.map((e, idx) => (
                        <div style={{ display: 'flex', alignItems: 'center' }} key={idx.toString()}>
                            <span style={{ ...emailItemStyle }}>{e}</span>
                            <div onClick={() => removeEmailFromlist(e)} style={{ ...buttonStyle, width: '58px', height: '29px' }}>
                                <Icon style={{ marginTop: '7px' }} type='delete' />
                            </div>
                        </div>
                    ))}
                </div> : ''}
            </div>
        )
    }

    render () {

        const { loading } = this.state
        const { close, editAgent } = this.props

        return (
            <div id="start-add-agent-wrapper" style={{ ...styles.wrapper }}>
                <div style={{ ...styles.container }}>
                    <div onClick={close} style={{ ...styles.close }}>+</div>

                    <div style={{ ...styles.popupTitle }}>
                        {editAgent ? "עריכת פרטי סוכן" : "הוספת סוכן"}
                    </div>

                    <div style={{ display: 'flex', paddingRight: '20px' }}>
                        {this.field('name')}
                        {this.field('phone')}
                    </div>

                    <div style={{ display: 'flex', paddingRight: '20px', marginTop: '20px' }}>
                        {this.field('email')}
                    </div>

                    <div style={{ ...styles.submitContainer }}>
                        <Button disabled={!this.valid()} style={{ margin: '0 10px 0 10px' }} onClick={this.submit}>
                            {editAgent ? "שמירה" : "הוספה"}
                        </Button>
                        {loading ? <Spin /> : <div style={{ width: '20px' }}></div>}
                    </div>

                </div>

            </div>
        )
    }
}

const styles = {
    wrapper: {
        position: 'absolute',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100vw',
        height: '100vh',
        background: 'none',
        top: 0,
        left: 0
    },
    container : {
        display: 'flex',
        flexDirection: 'column',
        // alignItems: 'center',
        // width: '760px',
        // minHeight: '300px',
        height: 'auto',
        borderRadius: '16px',
        background: 'white',
        border: 'solid #e3e3e3 1px',
        marginTop: '-160px',
        padding: '10px 10px 30px',
        zIndex: '1'
    },
    close: {
        padding: '0',
        background: 'none',
        border: 'none',
        rotate: '45deg',
        fontSize: '32px',
        position: 'relative',
        cursor: 'pointer',
        alignSelf: 'start',
        margin: '-5px 8px 0 0'
    },
    popupTitle: {
        fontSize: '20px',
        margin: '0 0 18px 0',
        paddingRight: '20px'
    },
    submitContainer: {
        display: 'flex',
        alignItems: 'center',
        alignSelf: 'center',
        margin: '30px 20px 0 0'
    },
    column: {
        display: 'flex',
        flexDirection: 'column'
    }
}


export default AddStartAgentPopup